module.exports = __webpack_public_path__ + "static/img/labourservices-4.cafff2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labourservices-4.png
// module id = Gyiy
// module chunks = 1